// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"781":"user-agreement","928":"privacy-policy"}[chunkId] + "." + {"781":"6a1951aa","928":"7771b05d"}[chunkId] + ".js";
};